/* TERAVIA — šípky pre jednoradové kategórie a odporúčané produkty */
(() => {
  const isFrench = String(document.documentElement.lang || 'sk').toLowerCase().split('-')[0] === 'fr';
  const selectors = [
    '.teravia-home .teravia-category-grid',
    '.teravia-home .product-grid.teravia-product-grid'
  ];

  const getStep = (row) => {
    const item = row.firstElementChild;
    if (!item) return Math.max(row.clientWidth * 0.8, 320);
    const styles = window.getComputedStyle(row);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return Math.max((item.getBoundingClientRect().width + gap) * 2, 320);
  };

  const updateControls = (row, prev, next) => {
    const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
    const hasOverflow = maxScroll > 4;
    prev.hidden = !hasOverflow;
    next.hidden = !hasOverflow;
    prev.disabled = !hasOverflow || row.scrollLeft <= 4;
    next.disabled = !hasOverflow || row.scrollLeft >= maxScroll - 4;
  };

  const build = (row) => {
    if (!row || row.dataset.teraviaCarousel === 'ready') return;
    row.dataset.teraviaCarousel = 'ready';

    const wrapper = document.createElement('div');
    wrapper.className = 'teravia-arrow-wrap';
    row.parentNode.insertBefore(wrapper, row);
    wrapper.appendChild(row);

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'teravia-arrow teravia-arrow-left';
    prev.setAttribute('aria-label', isFrench ? 'Faire défiler vers la gauche' : 'Posunúť doľava');
    prev.innerHTML = '&#10094;';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'teravia-arrow teravia-arrow-right';
    next.setAttribute('aria-label', isFrench ? 'Faire défiler vers la droite' : 'Posunúť doprava');
    next.innerHTML = '&#10095;';

    wrapper.append(prev, next);

    prev.addEventListener('click', () => {
      row.scrollBy({ left: -getStep(row), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      row.scrollBy({ left: getStep(row), behavior: 'smooth' });
    });

    row.addEventListener('scroll', () => updateControls(row, prev, next), { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateControls(row, prev, next));
      observer.observe(row);
    } else {
      window.addEventListener('resize', () => updateControls(row, prev, next), { passive: true });
    }

    requestAnimationFrame(() => updateControls(row, prev, next));
  };

  const init = (root = document) => {
    selectors.forEach((selector) => root.querySelectorAll(selector).forEach(build));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  const mutationObserver = new MutationObserver(() => init());
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
